import {
  Button,
  Icon,
  Input,
  Spin,
  Select,
  Card,
  Form,
  Tree,
  Modal,
  Row,
  Col,
  Tag,
  Typography,
  Checkbox,
  Popconfirm,
} from "antd";
import React, { Fragment } from "react";
import "../../components/general/drawer/AdaptiveDrawer.css";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { FileService } from "../../services/file/FileService";
import Page from "../general/Page";
import { showSuccessToast } from "../general/ToastHelper";
import { AccountGroupService } from "../../services/group/AccountGroupService";
import { CfgOneStepService } from "../../services/cfgOneStep/CfgOneStepService";
import "./CreateCallFlow.css";
import {
  DownOutlined,
  SoundOutlined,
  UsergroupAddOutlined,
  LeftCircleTwoTone,
} from "@ant-design/icons";
import DynamicForm from "../general/DynamicForm";
import covertJson2XmlAndUploadCallFlow from "./../../services/callFlow/generateICF";
import { da, th, tr } from "date-fns/locale";
import { element } from "prop-types";
import { Translation } from "react-i18next";
import i18next from "i18next";
import TreePrime from "../Tree/TreePrime";
import { Prompt } from "react-router-dom/cjs/react-router-dom.min";
const { Option } = Select;
const { Text } = Typography;

let array = [];
class CreateCallFlow extends React.Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("oneStepCallFlowConfig");
    this.fileService = new FileService();
    this.groupService = new AccountGroupService();
    this.cfgOneStep = new CfgOneStepService();

    this.state = {
      arrayTemp: [],
      selectedElementInTree: { title: "" },
      interruptOnDTMF: false,
      interruptOnDTMFInModal: false,
      choiceValueInModal: "",
      actionValueInModal: "2",
      groupValueInModal: 0,
      voiceValueInModal: 0,
      waitingValueInModal: -1,
      interruptInChoicesModal: false,
      fileIdInModal: null,
      modalTreeOpen: false,
      isFetching: false,
      groups: [],
      loading: false,
      inboundGroups: [],
      agentGroups: [],
      prompts: [],
      cfgOneStep: {},
      formChanged: false,
      mainActionValue: "1",
      secondAction: "1",
      voiceValue: 0,
      selectedPrompt: "",
      modalOpen: false,
      inputFields: [
        {
          choiceValue: "",
          actionValue: "2",
          groupValue: 0,
          voiceValue: 0,
          waitingValue: -1,
          interrupt: false,
        },
      ],
      showInputNodeName: true,
      newTree: [],
      expandedKeys: [],
      nodeName: "",
      flowName: this.props.recordData
        ? this.props.recordData.name.split(".")[0]
        : "",
      fileId:this.props.recordData ? this.props.recordData.fileId :"",   
      nodeNamesArray: [],
      nodeNamesToSelect: [],
      selectedNode: null,
      callFlow: {
        "user-defined": "",
        callflow: {
          action: [],
        },
      },
      callFlowActions: [
        {
          "cell-id": 2,
          type: "s",
          index: 0,
          "next-goto": 3,
          "call-type": 1,
        },
        {
          "cell-id": 3,
          type: "e",
          index: 2,
        },
      ],
      selectedNodesToDelete: [],
      mainTitle: props.callFlowData ? "Edit" : "Create",
      selectedPromptInModal: 0,
      disableAddToCallFlowButton: false,
      validateFlowName: "success",
      validateNodeName: "success",
      x: [],
      disabledDelete: false,
      callFlowForEdit: [],
      shouldBlockNavigation: true,
      preventNavigate: false,
      acceptNavigate: false,
      locationUrl: "",
    };
  }

  async componentDidMount() {
    this.setState({ isFetching: true });
    let [prompts, groups] = await Promise.all([
      this.getAllPrompts(),
      this.getAllGroups(),
    ]);
    this.setState({ prompts: prompts.ivrList });
    this.setState({ selectedPrompt: this.state.prompts[0] });
    let agentGroups = groups.ivrList.filter(
      (item) => item.groupType === "SXG" && item.groupStatus === "ACT"
    );
    this.setState({ agentGroups: agentGroups });

    if (this.props.callFlowData) {
      this.setState({ mainTitle: "Edit" });
      this.setState({ callFlowForEdit: JSON.parse(this.props.callFlowData) });
    }
    this.setState({ isFetching: false });
    localStorage.setItem("callflowPage", true);
  }

  componentDidUpdate = () => {
    if (this.state.shouldBlockNavigation) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  async getAllPrompts() {
    try {
      let data = await this.fileService.getPromptsService(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }

  async getAllGroups() {
    try {
      let data = await this.groupService.getAccountGroups(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }

  render() {
    let { isFetching } = this.state;
    return (
      <>
        <Prompt
          when={this.state.shouldBlockNavigation}
          // message="You have unsaved changes, are you sure you want to leave?"
          message={(location, action) => {
            this.setState({ locationUrl: location.pathname });
            if (this.state.acceptNavigate) {
              return true;
            }
            this.setState({ preventNavigate: true });
            return false;
          }}
        />
        {isFetching ? (
          <Spin></Spin>
        ) : (
          <TreePrime
            prompts={this.state.prompts}
            agentGroups={this.state.agentGroups}
            sessionId={this.props.context.session_id}
            back={async (flag) => {
              if (flag) {
                await this.setState({ shouldBlockNavigation: false });
              }
              if (this.props.callFlowData) {
                this.props.back();
              } else {
                let history = this.props.history;
                history.push("/home/configuration/callFlow");
              }
            }}
            treeData={
              this.props.callFlowData ? JSON.parse(this.props.callFlowData) : []
            }
            flowName={this.state.flowName}
            fileId={this.state.fileId}
            currLang={this.props.context.curr_lang}
            editFlag={this.props.callFlowData ? true : false}
            preventNavigate={this.state.preventNavigate}
            rejectNavigate={() => {
              this.setState({ preventNavigate: false });
            }}
            navigate={async () => {
              await this.setState({ shouldBlockNavigation: false });
              this.setState({ acceptNavigate: true });
              let history = this.props.history;
              history.push(this.state.locationUrl);
            }}
          />
        )}
      </>
    );
  }
}

export default Form.create()(withSharedStateConsumer(CreateCallFlow));
